<section *ngIf="banners.length > 0">
    <div tuiCarouselButtons class="banner-wrapper" (touchstart.passive.stop)="(0)">
        <button
            tuiIconButton
            tuiMode="onDark"
            type="button"
            icon="svg::chevron-left"
            class="banner-nav-btn banner-nav-btn-left"
            (click)="navigate(-1)"
        ></button>
        <tui-carousel
            #carousel
            class="max-h-[516px] banner"
            [draggable]="true"
            [duration]="duration"
            [(index)]="index"
            [style.width]="width"
            [style.height]="height"
        >
            <ng-container *ngFor="let item of banners">
                <img
                    *tuiItem
                    class="mx-auto object-cover w-full {{ aspectRatio }}"
                    [ngSrc]="item"
                    [width]="width"
                    [height]="height"
                    priority="true"
                    alt=""
                    draggable="false"
                />
            </ng-container>
        </tui-carousel>
        <button
            tuiIconButton
            tuiMode="onDark"
            type="button"
            icon="svg::chevron-right"
            class="banner-nav-btn banner-nav-btn-right"
            (click)="navigate(1)"
        ></button>
    </div>

    <!--<tui-pagination
        *ngIf="banners.length > 1"
        size="s"
        class="pagination"
        [length]="banners.length"
        [(index)]="index"
    ></tui-pagination>-->
</section>
